import axios from 'axios'
import React, { useState, useEffect, useMemo, Fragment, useRef } from 'react'
import { FormControl, InputLabel, Input, FormHelperText, ButtonGroup, Menu } from '@mui/material'
import WebService from '@util/webService'
import { encodeParams, findCode, getAction, printVariable } from '@util/helper'
// redux
import { useSelector, useDispatch } from 'react-redux'
// MUI Table
import CssBaseline from '@mui/material/CssBaseline'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
// react-table
import { useTable, useExpanded } from 'react-table'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import SearchIcon from '@mui/icons-material/Search'
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField, withStyles, InputBase } from '@mui/material'
import { styled, alpha } from '@mui/material/styles'
import '@scss/App.scss'
import Button from '@mui/material/Button'
import FlatButton from '@components/FlatButton'
import useSnackbar from '@hooks/useSnackbar'
import MyTableHead from '@components/MyTableHead'
import useIndicator from '@hooks/useIndicator'
import Indicator from '@components/Indicator'
import MyDialog from '@components/MyDialog'
import useForm from '@hooks/useForm'
import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
// pagination
import { useTheme } from '@mui/material/styles'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import LastPageIcon from '@mui/icons-material/LastPage'
import ControlPointIcon from '@mui/icons-material/ControlPoint'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import Paper from '@mui/material/Paper'
import moment from 'moment'
import { Avatar, Grid, Container } from '@mui/material/'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { isNewExpression } from '@babel/types'
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete'
import { searchSchool } from '@util/helper'
import TeacherRegiPart from './teacher-regi.part'
import ConfirmDialog from '@components/ConfirmDialog'
import TeacherRegiPartHistory from '@pages/teacher/teacher-regi.part.history'
import TeacherRegiPartPick from '@pages/teacher/teacher-regi.part.pick'
import TeacherRegiPartBill from '@pages/teacher/teacher-regi.part.bill'
import { useParams } from 'react-router-dom'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import TeacherNoticePartMod from '@pages/teacher/teacher-notice.part.mod'
import TeacherRegiPartAgency from '@pages/teacher/teacher-regi.part.agency'
import TeacherRegiPartName from './teacher-regi.part.name'
import useAlert from '@hooks/useAlert'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabContext from '@mui/lab/TabContext'
import TabPanel from '@mui/lab/TabPanel'
import Divider from '@mui/material/Divider'
import TeacherRegiPartUpload from './teacher-regi.part.upload'
import TeacherRegiPartDownload from './teacher-regi.part.download'
import { download } from '@util/helper'
import { useLocation } from 'react-router-dom'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined'
import TeacherMessagePartPost from './teacher-message.part.post'

/**
 -1 <= phase < 0 : 강좌 데이터 검증 전(특히 파일 업로드 한 경우)
 0 <= phase < 1 : 강좌 데이터 완료
 1 <= phase < 2 : 수강 신청 중
 2 <= phase < 3 : 모집 종료, 학생 선발 전
 3 <= phase < 4 : 학생 선발 후, 등록 중
 4 <= phase < 5 : 등록 마감 강좌 시작 전
 5 <= phase     : 개강준비 완료
 */
const Boxs = styled(Box)`
  padding-bottom: 40px !important;
`
const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`
const RLTN_CODE = 'S003'
const TeacherRegiPage = () => {
  const g_sel_code = 'SA07'
  const g_stat_code = 'SA12'
  const g_week_code = 'SB07'
  const { more } = useParams()
  const inputRef = useRef()
  const dateFormat = 'YYYY-MM-DD HH:mm:ss'
  const [detailScreen, set_detailScreen] = useState(false)
  const [isNew, set_isNew] = useState(false)
  const [schoolList, set_schoolList] = useState([])
  const [teacherList, set_teacherList] = useState([])
  const [smstList, set_smstList] = useState([])
  const [lessonList, set_lessonList] = useState([])
  const [lectureList, set_lectureList] = useState([])
  const [selCodeList, set_selCodeList] = useState([])
  const [statCodeList, set_statCodeList] = useState([])
  const [weekCodeList, set_weekCodeList] = useState([])
  const postHandler = useState(false)
  const location = useLocation()
  const curLocationRef = useRef(location)
  const fields = [
    { field: 'smstName', placeholder: '년도/기수', type: 'text', value: '', visible: true, canSrch: false, selList: smstList },
    { field: 'id', placeholder: '강좌ID', type: 'text', value: -1, visible: more && more === 'more', canSrch: false, selList: [] },
    {
      field: 'title',
      placeholder: '강좌명',
      type: 'text',
      value: '',
      visible: true,
      canSrch: false,
      disabled: false,
      selList: [],
    },
    {
      field: 'rcrNum',
      placeholder: '모집',
      type: 'text',
      value: '',
      visible: true,
      canSrch: false,
      disabled: false,
      selList: [],
    },
    {
      field: 'reqNum',
      placeholder: '신청',
      type: 'text',
      value: '',
      visible: true,
      canSrch: false,
      disabled: false,
      selList: [],
    },
    {
      field: 'prcNum',
      placeholder: '진행',
      type: 'text',
      value: '',
      visible: true,
      canSrch: false,
      disabled: false,
      selList: [],
    },

    {
      field: 'sttNum',
      placeholder: '등록',
      type: 'text',
      value: '',
      visible: true,
      canSrch: false,
      disabled: false,
      selList: [],
    },
    {
      field: 'statName',
      placeholder: '상태',
      type: 'text',
      value: '',
      visible: true,
      canSrch: false,
      disabled: false,
      selList: [],
    },

    {
      field: 'phase',
      placeholder: '단계',
      type: 'text',
      value: '',
      visible: more && more === 'more',
      canSrch: false,
      disabled: false,
      selList: [],
    },
  ]
  // const [fields, set_fields] = useState([...defFields])
  const gdnFields = [
    { field: 'name', placeholder: '성명' },
    { field: 'loginId', placeholder: 'ID' },
    { field: 'phone', placeholder: '전화번호' },
    { field: 'phoneCertYn', placeholder: '인증여부' },
  ]
  const visibleColumns = fields.filter((col) => col.visible)
  const defRecord = {}
  fields.forEach((d) => {
    defRecord[d.field] = d.value
  })
  defRecord.schoolList = []
  const defTerms = {}
  fields
    .filter((col) => col.canSrch)
    .map((d) => d.field)
    .forEach((d) => (defTerms[d] = ''))
  const recordRef = useRef(defRecord)
  const [dataList, set_dataList] = useState([])
  const [schoolGroup, set_schoolGroup] = useState([])
  const [skipPageReset, setSkipPageReset] = React.useState(false)
  const [openSnackbar, renderSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const { alert, renderAlert } = useAlert()
  const dgHandler = useState(false)
  const [selIdx, set_selIdx] = useState(-1)
  const [pageNum, set_pageNum] = useState(0)
  const [pageSize, set_pageSize] = useState(10)
  const [totalCount, set_totalCount] = useState(0)
  const [pageInfo, set_pageInfo] = useState({ pageNum: 0, pageSize: -1 })
  const [terms, _set_terms] = useState(defTerms)
  const [fontSize, set_fontSize] = useState(12)
  const [selStudentList, set_selStudentList] = useState([])
  const termsRef = useRef(terms)
  const [schoolRowSpan, set_schoolRowSpan] = useState({})
  const [openName, set_openName] = useState(false)
  const [openHistory, set_openHistory] = useState(false)
  const [openPick, set_openPick] = useState(false)
  const [openBill, set_openBill] = useState(false)
  const [tabValue, set_tabValue] = useState('1')
  const agencyHandler = useState(false)
  // redux
  const codeGroups = useSelector((state) => state.codeGroupReducer)
  const codes = useSelector((state) => state.codeReducer)
  const schools = useSelector((state) => state.schoolReducer)
  const account = useSelector((state) => state.accountReducer)
  const schola = useSelector((state) => state.scholaReducer)
  //
  const actionHandler = useState(false)
  const dgRef = useRef()
  const dgRef2 = useRef()
  const set_terms = (data) => {
    termsRef.current = data
    _set_terms(data)
  }

  const onLoad = async () => {
    openIndicator()
    let smstGroup = await fetchLecturesWithExtra()
    
    // smstGroup = smstGroup.filter(r => r.userId === account.user.id)
    Object.keys(smstGroup).forEach((key) => {
      // 출강 강좌의 수강신청만 조회
      
      let lectures = smstGroup[key]
      // TODO, 보조 강사는 ????
      // lectures = lectures.filter((r) => +r.userId === +account.user.id)
      lectures = lectures.filter(r =>{
        if(+r.userId === +account.user.id) {
          return true
        }
        if(r.teachers.length > 0) {
          const ids = r.teachers.map( r => r.id)
          if(ids.includes(account.user.id)) {
            return true
          }
        }
        return false
      })
      lectures.sort((a, b) => a.title.localeCompare(b.title))
      smstGroup[key] = lectures
    })
    console.log('smstGroup=>', smstGroup)
    set_dataList(smstGroup)
    closeIndicator()
  }

  const onSaveEmptyPickList = async () => {
    const url = `/lecture/pick/${schola.id}/${recordRef.current.id}`

    const formData = new FormData()
    const data = {
      pickIdList: [],
      excIdList: [],
    }

    const jsonData = JSON.stringify(data)

    formData.append('body', new Blob([jsonData], { type: 'application/json' }))
    openIndicator()
    const resp = await axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    closeIndicator()

    if (resp.data.repCode === 'ack') {
      alert('처리되었습니다.')
      onLoad()
    } else {
      alert(resp.data.repMessage)
    }
  }

  const fetchLectures = async () => {
    const url = `/regi/school/${schola.id}`
    const resp = await WebService.get(url)
    if (resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const records = JSON.parse(repMessage.records)
      records.forEach((row) => {
        row.statName = findCode(codes, 'SA08', row.statCode)?.name ?? ''
      })
      return records
    } else {
      openSnackbar(resp.repMessage)
    }
  }
  const fetchLecturesWithExtra = async () => {
    let url = `/lecture/extra/${schola.id}`
    const newTerms = {}
    let tempList
    let resp = await WebService.get(url, {
      pageNum: pageInfo.pageNum,
      pageSize: pageInfo.pageSize,
      terms: JSON.stringify(newTerms),
    })
    if (resp.repCode !== 'ack') {
      openSnackbar(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const originList = JSON.parse(repMessage.records)
    if (repMessage.totalCount) {
      const totalCount = repMessage.totalCount
      set_totalCount(totalCount)
    }
    const records = originList.reduce((acc, cur, idx, arr) => {
      const lecture = cur.lecture
      lecture.smstId = cur.smst.id
      lecture.year = cur.smst.year
      lecture.gisu = cur.smst.gisu
      lecture.smstPhase = cur.smst.phase
      lecture.teacherName = cur.teacher.name
      lecture.userId = cur.teacher.id
      lecture.statName = findCode(codes, 'SA08', lecture.statCode)?.name ?? ''
      lecture.overCode = cur.smst.overCode
      lecture.smstSelCode = cur.smst.selCode
      acc.push(lecture)
      return acc
    }, [])

    //
    const smstGroup = records.reduce((acc, cur) => {
      const key = '' + cur.year + '/' + cur.gisu
      if (acc[key]) {
        acc[key].push(cur)
      } else {
        acc[key] = [cur]
      }
      cur.groupId = key
      return acc
    }, {})
    return smstGroup
  }

  const canDownload = (row) => {
    return row.phase >= 3 && row.statCode !== 'S004' && row.rcrNum < row.reqNum
  }

  const handleDownload = async (row) => {
    if (row.selCode == 'S002') {
      alert('선착순의 경우에는 동영상을 저장하지 않습니다.')
      return
    }
    const serverUrl = encodeURI(`/lecture/download/webm/${row.id}`)
    const response = await axios.get(serverUrl, {
      responseType: 'blob', // Set responseType to 'blob' for binary data
    })
    if (!response) {
      alert('파일이 존재하지 않습니다.')
    }

    //
    const contentDispositionHeader = response.headers['content-disposition']
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
    const matches = filenameRegex.exec(contentDispositionHeader)
    let suggestedFilename = 'downloaded_file' // Default filename if not found

    if (matches != null && matches[1]) {
      suggestedFilename = decodeURIComponent(matches[1]).replace(/['"]/g, '') // Remove quotes if present
    }

    // Create a Blob object from the response data
    const blob = new Blob([response.data], { type: response.headers['content-type'] })

    // Create a temporary URL for the Blob
    const url = window.URL.createObjectURL(blob)

    // Create a link element to trigger the download
    const link = document.createElement('a')
    link.href = url
    link.download = suggestedFilename
    document.body.appendChild(link)

    // Trigger the download
    link.click()

    // Clean up the temporary URL and link
    window.URL.revokeObjectURL(url)
    document.body.removeChild(link)
  }

  const handleSampleDownload = async (row) => {
    const url = `/regi/download/tmpl`
    await download(url)
  }

  const onDetail = async (id) => {
    set_detailScreen(true)
    dgHandler[1](true)
  }
  const onDiscard = async (lectureId) => {
    openIndicator()
    const url = `/lecture/discard/${schola.id}/${lectureId}`
    const resp = await WebService.post(url)
    if (resp.repCode === 'ack') {
      alert('처리 되었습니다.')
      onLoad()
    } else {
      alert(resp.repMessage)
    }
    closeIndicator()
  }
  const onStartReq = async (lectureId) => {
    openIndicator()
    const url = `/lecture/req/start/${schola.id}/${lectureId}`
    const resp = await WebService.post(url)
    if (resp.repCode === 'ack') {
      alert('처리 되었습니다.')
      onLoad()
    } else {
      alert(resp.repMessage)
    }
    closeIndicator()
  }
  const onQuitReq = async (lectureId) => {
    openIndicator()
    const url = `/lecture/req/quit/${schola.id}/${lectureId}`
    const resp = await WebService.post(url)
    if (resp.repCode === 'ack') {
      alert('처리 되었습니다.')
      onLoad()
    } else {
      alert(resp.repMessage)
    }
    closeIndicator()
  }

  const onReopen = async (lectureId) => {
    const url = `/lecture/reopen/${schola.id}/${lectureId}`
    openIndicator()
    const resp = await WebService.post(url)
    if (resp.repCode === 'ack') {
      alert('처리 되었습니다.')
      onLoad()
    } else {
      alert(resp.repMessage)
    }
    closeIndicator()
  }

  const onPauseReq = async (lectureId) => {
    openIndicator()
    const url = `/lecture/req/pause/${schola.id}/${lectureId}`
    const resp = await WebService.post(url)
    if (resp.repCode === 'ack') {
      alert('처리 되었습니다.')
      onLoad()
    } else {
      alert(resp.repMessage)
    }
    closeIndicator()
  }

  const onAttdnc = async (lectureId) => {
    openIndicator()
    const url = `/attdnc/lecture/${lectureId}`
    const resp = await WebService.post(url)
    if (resp.repCode === 'ack') {
      openSnackbar('출석부를 생성하였습니다.')
      onLoad()
    } else {
      alert(resp.repMessage)
    }
    closeIndicator()
  }

  const onOpenLecture = async (lectureId) => {
    openIndicator()
    const url = `/lecture/open/${schola.id}/${lectureId}`
    const resp = await WebService.post(url)
    if (resp.repCode === 'ack') {
      alert('개강상태로 변경되었습니다.')
      onLoad()
    } else {
      alert(resp.repMessage)
    }
    closeIndicator()
  }

  const onCloseLecture = async (lectureId) => {
    openIndicator()
    const url = `/lecture/close/${schola.id}/${lectureId}`
    const resp = await WebService.post(url)
    if (resp.repCode === 'ack') {
      alert('종강상태로 변경되었습니다.')
      onLoad()
    } else {
      alert(resp.repMessage)
    }
    closeIndicator()
  }

  const onResetLecture = async (lectureId) => {
    openIndicator()
    const url = `/lecture/reset/${schola.id}/${lectureId}`
    const resp = await WebService.post(url)
    if (resp.repCode === 'ack') {
      alert('리셋되었습니다.')
      onLoad()
    } else {
      alert(resp.repMessage)
    }
    closeIndicator()
  }

  const onRecover = async (lectureId) => {
    const url = `/lecture/recover/${schola.id}/${lectureId}`
    openIndicator()
    const resp = await WebService.post(url)
    closeIndicator()
    if (resp.repCode === 'ack') {
      alert('이전 상태로 복구 되었습니다.')
      onLoad()
    } else {
      alert(resp.repMessage)
    }
  }
  const handleChangePage = (event, newPage) => {
    console.log(`newPage:${newPage}`)
    set_pageInfo({ ...pageInfo, pageNum: newPage })
  }
  const handleChangeRowsPerPage = (event) => {
    const pageSize = parseInt(event.target.value, 10)
    console.log(`event target value:${pageSize}`)
    set_pageInfo({ pageNum: 0, pageSize: pageSize })
  }
  const TablePaginationActions = (props) => {
    const theme = useTheme()
    const { count, page, rowsPerPage, onPageChange } = props
    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0)
    }
    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1)
    }
    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1)
    }
    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
    }
    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page">
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="next page">
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="last page">
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    )
  }
  const handleTabChange = (event, newValue) => {
    set_tabValue(newValue)
  }
  const loadSelStudentList = async (lectureId) => {
    const url = `/regi/sel/student`
    const action = getAction(url, { lectureId: lectureId })
    const resp = await WebService.get(action)
    set_selStudentList([])
    if (resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const records = JSON.parse(repMessage.records)
      set_selStudentList(records)
      openSnackbar('선밞/마감하였습니다.')
    }
  }
  const genAttdnc = async (lectureId) => {
    const url = `/attdnc/${lectureId}`
    const action = getAction(url, {})
    const resp = await WebService.post(action)
    if (resp.repCode === 'ack') {
      openSnackbar('출석부를 생성하였습니다.')
    } else {
      openSnackbar(resp.repMessage)
    }
  }
  const onCloseBill = async (lectureId) => {
    const url = `/lecture/bill/quit/${schola.id}/${lectureId}`
    const resp = await WebService.post(url)
    if (resp.repCode === 'ack') {
      alert('처리되었습니다.')
      onLoad()
    } else {
      alert(resp.repMessage)
    }
  }
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }))

  useEffect(() => {
    if (curLocationRef.current.key !== location.key) {
      curLocationRef.current = location
      set_pageInfo({ pageNum: 0, pageSize: 10 })
    }
  }, [location])

  useEffect(() => {
    onLoad()
  }, [pageInfo])

  const dg_title = '수강신청 정보'
  const memo_DgContent = useMemo(() => {
    return <TeacherRegiPart />
  }, [recordRef.current, detailScreen])

  const Body = ({ smstPhase }) => {
    console.log('rendeirng body.....')
    const [anchorEl, setAnchorEl] = useState(null)
    const theme = useTheme()
    const handleMenuClick = (event, row) => {
      event.currentTarget.getBoundingClientRect()
      setAnchorEl(event.currentTarget)
    }
    const handleMenuClose = () => {
      setAnchorEl(null)
    }

    const fetchSmstList = async () => {
      const url = `/smst/last/1/${schola.id}`
      openIndicator()
      const resp = await WebService.get(url, {})
      closeIndicator()
      if (resp.repCode !== 'ack') {
        alert(resp.repMessage)
        return
      }
      const repMessage = JSON.parse(resp.repMessage)
      const smstList = JSON.parse(repMessage.records)
      return smstList
    }

    return (
      <div ref={inputRef}>
        {Math.floor(smstPhase) === 1 ? (
          <>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <Button
                startIcon={<FileDownloadOutlinedIcon />}
                variant="outlined"
                color="primary"
                size="small"
                sx={{ mr: 1 }}
                onClick={async () => {
                  const smst = await fetchSmstList()
                  if (smst) {
                    dgRef2.current.open()
                  }
                }}
              >
                명단 다운로드
              </Button>
            </div>
          </>
        ) : null}

        <div style={{ paddingTop: 20 }}>
          <MUITable sx={{ minWidth: 1200 }}>
            <MyTableHead>
              <TableRow>
                {fields.map((col, index) => {
                  if (col.visible) {
                    return (
                      <TableCell key={index} size="small">
                        {col.placeholder}
                        {col.canSrch ? (
                          <Fragment>
                            <TextField
                              label=""
                              variant="outlined"
                              size="small"
                              inputProps={{
                                style: {
                                  fontSize: '0.875em',
                                  padding: 5,
                                  backgroundColor: '#fff',
                                },
                              }}
                              value={terms[col.field]}
                              onChange={(e) => {
                                const newTerms = { ...terms }
                                newTerms[col.field] = e.target.value
                                set_terms(newTerms)
                              }}
                            />
                          </Fragment>
                        ) : (
                          <Fragment></Fragment>
                        )}
                      </TableCell>
                    )
                  }
                })}
                <TableCell size="small" align={'center'}>
                  관리
                </TableCell>
              </TableRow>
            </MyTableHead>
            <TableBody>
              {dataList &&
                Object.keys(dataList).map((groupId, gidx) =>
                  dataList[groupId].findIndex((r) => Math.floor(+r.smstPhase) === +smstPhase) >= 0 ? (
                    <Fragment key={gidx}>
                      <TableRow>
                        <TableCell rowSpan={dataList[groupId].length + 1}>{dataList[groupId].length > 0 ? groupId : '데이터 없음'}</TableCell>
                      </TableRow>
                      {dataList[groupId].map((row, rowIdx) => (
                        <TableRow key={rowIdx} onMouseEnter={() => (recordRef.current = row)}>
                          {fields.map((col, colIdx) =>
                            col.visible && col.field !== 'smstName' ? (
                              <TableCell key={colIdx}>
                                <Typography variant="body2" fontWeight={col.field === 'statName' ? 'bold' : 'normal'}>
                                  {row[col.field]}
                                </Typography>
                              </TableCell>
                            ) : null
                          )}
                          <TableCell size="small" align={'center'}>
                            {/* <FlatButton disabled={row.statCode === "S004"} variant='outlined' size='small' style={{ marginRight: 5 }} onClick={() => set_openName(true)}> */}
                            <FlatButton variant="outlined" size="small" style={{ marginRight: 5 }} onClick={() => set_openName(true)}>
                              명단
                            </FlatButton>
                            <FlatButton variant="outlined" size="small" style={{ marginRight: 5 }} 
                            onClick={() => {
                              postHandler[1](true)
                            }}>
                              알림
                            </FlatButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </Fragment>
                  ) : null
                )}
            </TableBody>
          </MUITable>
        </div>
      </div>
    )
  }
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <div style={{ paddingRight: 10 }}>
          <h1>수강신청 목록 </h1>
        </div>
      </div>
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={tabValue}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', position: 'sticky', top: 0, backgroundColor: '#fff' }}>
            <TabList onChange={handleTabChange} aria-label="lab API tabs example">
              <Tab label="현재" value="1" />
              <Tab label="이전내역" value="2" />
            </TabList>
          </Box>
          <TabPanel value="1" sx={{ minHeight: '60vh' }}>
            <Body smstPhase="1" />
          </TabPanel>
          <TabPanel value="2" sx={{ minHeight: '60vh' }}>
            <Body smstPhase="2" />
          </TabPanel>
        </TabContext>
      </Box>
      <div>
        {postHandler[0] ? (
          <TeacherMessagePartPost dialogHandler={postHandler} tid={recordRef.current.id} msgType="push" />
        ) : null}
        {agencyHandler[0] ? <TeacherRegiPartAgency record={recordRef.current} dialogHandler={agencyHandler} callback={onLoad} /> : null}
        {openName ? <TeacherRegiPartName record={recordRef.current} open={openName} onClose={() => set_openName(false)} reload={onLoad} /> : null}
        {openPick ? <TeacherRegiPartPick record={recordRef.current} open={openPick} onClose={() => set_openPick(false)} reload={onLoad} /> : null}
        {openBill ? <TeacherRegiPartBill record={recordRef.current} open={openBill} onClose={() => set_openBill(false)} reload={onLoad} /> : null}
        {<TeacherRegiPartUpload ref={dgRef} callback={onLoad} />}
        {<TeacherRegiPartDownload ref={dgRef2} callback={null} />}
        {renderSnackbar()}
        {renderIndicator()}
        {renderAlert()}
      </div>
    </>
  )
}
export default TeacherRegiPage
